(()=>{
 'use strict';
 const page=document.querySelector('[data-koll-product]');
 if(!page)return;
 let labels;
 try{labels=JSON.parse(page.querySelector('[data-product-consistency-settings]').textContent);}catch{return;}
 const states=new WeakMap();
 const text=(key,values={})=>Object.entries(values).reduce((s,[name,value])=>s.replaceAll('__'+name.toUpperCase()+'__',String(value)),labels[key]||'');
 const rails=[...page.querySelectorAll('[data-family-cards],.koll-color-choices .koll-choice-rail')];
 function refreshRail(rail){
  let state=states.get(rail);
  if(!state){
   const tools=document.createElement('div'),count=document.createElement('span'),toggle=document.createElement('button');
   tools.className='koll-choice-tools';count.className='koll-choice-count';count.setAttribute('aria-live','polite');
   toggle.className='koll-choice-toggle';toggle.type='button';
   rail.id=rail.id||'koll-choice-grid-'+String(statesCount++);
   toggle.setAttribute('aria-controls',rail.id);tools.append(count,toggle);rail.after(tools);
   state={expanded:false,count,toggle};states.set(rail,state);
   toggle.addEventListener('click',()=>{state.expanded=!state.expanded;refreshRail(rail);if(!state.expanded){toggle.focus({preventScroll:true});rail.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}});
  }
  const cards=[...rail.querySelectorAll('.koll-choice-card')],eligible=cards.filter(card=>!card.hidden);
  const visibleCards=new Set(eligible.slice(0,4)),current=eligible.find(card=>card.matches('[aria-current="page"],[aria-pressed="true"]'));
  if(current&&!visibleCards.has(current)){visibleCards.delete(eligible[3]);visibleCards.add(current);}
  for(const card of cards)card.toggleAttribute('data-choice-folded',!state.expanded&&!card.hidden&&!visibleCards.has(card));
  const countText=text('choiceCount',{visible:state.expanded?eligible.length:Math.min(4,eligible.length),count:eligible.length});
  if(state.count.textContent!==countText)state.count.textContent=countText;
  const hide=eligible.length<=4;if(state.toggle.hidden!==hide)state.toggle.hidden=hide;
  const toggleText=state.expanded?text('showLess'):text('showAll',{count:eligible.length});
  if(state.toggle.textContent!==toggleText)state.toggle.textContent=toggleText;
  state.toggle.setAttribute('aria-expanded',String(state.expanded));
  if(state.count.hidden!==(eligible.length<=1))state.count.hidden=eligible.length<=1;
  syncNavigation();
 }
 function syncNavigation(){
  const link=page.querySelector('[data-pdp-choices-link]');
  if(link){const multipleRail=[...page.querySelectorAll('.koll-choice-rail')].some(rail=>[...rail.querySelectorAll('.koll-choice-card')].filter(card=>!card.hidden).length>1);
   const multipleSelect=[...page.querySelectorAll('[data-product-option]')].some(select=>[...select.options].filter(option=>!option.disabled).length>1);
   const hide=!multipleRail&&!multipleSelect;if(link.hidden!==hide)link.hidden=hide;
  }
  const note=page.querySelector('[data-facts-help]'),values=[...page.querySelectorAll('.koll-product-decision-facts [data-fact-key]')];
  if(note){const hide=!values.length||!values.every(node=>node.textContent.trim()===labels.notSpecified);if(note.hidden!==hide)note.hidden=hide;const support=page.querySelector('.koll-service-link'),target=note.querySelector('[data-facts-help-link]');if(support&&target&&target.href!==support.href)target.href=support.href;}
 }
 let statesCount=0;
 for(const rail of rails){refreshRail(rail);new MutationObserver(()=>refreshRail(rail)).observe(rail,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','aria-current','aria-pressed']});}
 page.querySelector('#koll-variant')?.addEventListener('change',syncNavigation);
 syncNavigation();
})();
